/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.PaymentInstrumentType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.PaymentInstrumentType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum PaymentInstrumentType_ {
   /// <summary>
   ///   Other Process (oth)
   /// </summary>
   OtherProcess = 0,
   /// <summary>
   ///   EFT Record (ACH) (ach)
   /// </summary>
   EftRecord = 1,
   /// <summary>
   ///   Payment Card (card)
   /// </summary>
   PaymentCard = 2,
   /// <summary>
   ///   Bank Draft (Check) (check)
   /// </summary>
   BankDraft = 3,
   /// <summary>
   ///   Administrative (Comp) (comp)
   /// </summary>
   Administrative = 4,
   /// <summary>
   ///   Cash (cash)
   /// </summary>
   Cash = 5,
   /// <summary>
   ///   International Bank Transfer (ibt)
   /// </summary>
   InternationalBankTransfer = 6,
   /// <summary>
   ///   Online Money Transfer (omt)
   /// </summary>
   OnlineMoneyTransfer = 7
}

export const PaymentInstrumentTypes: PaymentInstrumentType[] = [
   {
      code: PaymentInstrumentType_.OtherProcess,
      literal: 'OtherProcess',
      description: 'Other Process',
      shortDescription: 'oth',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.EftRecord,
      literal: 'EftRecord',
      description: 'EFT Record (ACH)',
      shortDescription: 'ach',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.PaymentCard,
      literal: 'PaymentCard',
      description: 'Payment Card',
      shortDescription: 'card',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.BankDraft,
      literal: 'BankDraft',
      description: 'Bank Draft (Check)',
      shortDescription: 'check',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.Administrative,
      literal: 'Administrative',
      description: 'Administrative (Comp)',
      shortDescription: 'comp',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.Cash,
      literal: 'Cash',
      description: 'Cash',
      shortDescription: 'cash',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.InternationalBankTransfer,
      literal: 'InternationalBankTransfer',
      description: 'International Bank Transfer',
      shortDescription: 'ibt',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   },
   {
      code: PaymentInstrumentType_.OnlineMoneyTransfer,
      literal: 'OnlineMoneyTransfer',
      description: 'Online Money Transfer',
      shortDescription: 'omt',
      listPriority: 0,

      typeName: "PaymentInstrumentType"
   }
]

export class PaymentInstrumentType implements IDomainModel {
   code: PaymentInstrumentType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: PaymentInstrumentType_): PaymentInstrumentType {
      return PaymentInstrumentTypes.find(d => d.code === code)
   }
}
